import inputData from './inputData/employee-feedback-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'employee-feedback-form',
  title: 'Employee Feedback Form',
  description: 'Invite honest input from your team so you can improve processes, culture, and communication.',
  image: '/images/templates/employee-feedback-form.png',
  tags: ['human-resources', 'get-feedback', 'recruit-talent'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

